var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',_vm._g(_vm._b({staticClass:"subheading text-uppercase font-weight-medium",class:_vm.removeBottomSpacing ? '' : 'mb-3'},'h2',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }